module.exports = __webpack_public_path__ + "static/media/sample-club.92cfb95d.png";